import React, {Component} from 'react';
import {config, SERVICE_API,DISPATCH_ID,SERVICE_RESPONSE} from "../libs/utils/Const";
import {ApiClient} from "../libs/apiClient/ApiClient";
import $ from 'jquery';
import {connect} from 'react-redux';
import CurrencyFormat from 'react-currency-format';

let apiClient = ApiClient.getInstance();

class ProfieldModel extends Component {
    state = {
        infoSN: [],
    }

    async componentDidMount () {
        // Información del modal
        await apiClient.getDataProfiel().then( (response) => {
            if (response.status === SERVICE_RESPONSE.SUCCESS) {
                this.setState({
                    infoSN: response.data,
                });
            };
        });
    }

    render() {
        const {sessionReducer: {user}} = this.props;
        const {infoSN} = this.state;
        return (
            <div className="modal fade" id="dataProfiel" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style={{border: "none", textAlign: 'center'}}>
                <div className="modal-dialog modal-lg" role="document" style={{margin: '1.75rem auto'}}>
                    <div className="modal-content">
                        <div className="modal-header" style={{background: config.navBar.textColorBlack, color: config.navBar.textCategories}}>
                            <h5 className="modal-title" style={{color: "white"}}>Detalle de la cuenta</h5>
                            <button type="button" style={{color: config.navBar.textColor}} className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body bg3">
                            {infoSN && infoSN.body && infoSN.body.map(item => {
                                return <div className="container" key={item}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h5>Código</h5>
                                            <label>{item.CardCode}</label>
                                        </div>
                                        <div className="col-md-6">
                                            <h5>Socio de negocio</h5>
                                            <label>{item.CardName}</label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h5>Condiciones de pago</h5>
                                            <label>{item.CondicionPago}</label>
                                        </div>
                                        <div className="col-md-6">
                                            <h5>Límite de crédito</h5>
                                            <label>
                                                <CurrencyFormat 
                                                    value={Number(item.LimiteCredito) || 0} 
                                                    displayType={'text'} 
                                                    thousandSeparator={'.'}
                                                    decimalSeparator = {false}
                                                    fixedDecimalScale={true} 
                                                    decimalScale={0} 
                                                    // prefix={config.general.pricetype + ' '}
                                                    prefix={'$ '}
                                                    // suffix={' ' + config.general.currency}
                                                    >
                                                </CurrencyFormat>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h5>Documentos vencidos</h5>
                                            <label>{item.DocsVencidos}</label>
                                        </div>
                                        <div className="col-md-6">
                                            <h5>Total facturado</h5>
                                            <label>
                                                <CurrencyFormat 
                                                    value={Number(item.Facturado)} 
                                                    displayType={'text'} 
                                                    thousandSeparator={'.'}
                                                    decimalSeparator = {false}
                                                    fixedDecimalScale={true} 
                                                    decimalScale={0} 
                                                    // prefix={config.general.pricetype + ' '}
                                                    prefix={'$ '}
                                                    // suffix={' ' + config.general.currency}
                                                    >
                                                </CurrencyFormat>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h5>Total pagado</h5>
                                            <label>
                                                <CurrencyFormat 
                                                    value={Number(item.Pagado)} 
                                                    displayType={'text'} 
                                                    thousandSeparator={'.'}
                                                    decimalSeparator = {false} 
                                                    fixedDecimalScale={true} 
                                                    decimalScale={0} 
                                                    // prefix={config.general.pricetype + ' '}
                                                    prefix={'$ '}
                                                    // suffix={' ' + config.general.currency}
                                                    
                                                    >
                                                </CurrencyFormat>
                                            </label>
                                        </div>
                                        <div className="col-md-6">
                                            <h5>Total vencidos</h5>
                                            <label>
                                                <CurrencyFormat 
                                                    value={Number(item.MontoVencido)} 
                                                    displayType={'text'} 
                                                    thousandSeparator={'.'}
                                                    decimalSeparator = {false} 
                                                    fixedDecimalScale={true} 
                                                    decimalScale={0} 
                                                    // prefix={config.general.pricetype + ' '}
                                                    prefix={'$ '}
                                                    // suffix={' ' + config.general.currency}
                                                    >
                                                </CurrencyFormat>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            })}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn" data-dismiss="modal" style={{backgroundColor:'black', color:'white'}}>Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        itemsReducer: store.ItemsReducer,
        notificationReducer: store.NotificationReducer,
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer,
        shoppingCartReducer: store.ShoppingCartReducer
    };
}

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value}),
        setItemDetailsSearch: value => dispatch({type: DISPATCH_ID.ITEMS_SET_ITEM_DETAILS, value}),
        setItemsSearch: value => dispatch({type: DISPATCH_ID.ITEMS_SET_ITEMS, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProfieldModel);
